import { Route, Routes } from 'react-router-dom';
import './App.css';
import { useState } from 'react';
import "bootstrap-icons/font/bootstrap-icons.css"; 
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";


import Sidebar from './Sidebar.js';
import Upload from './Upload.js';
import Navbar from './Navbar.js';
import List from './VideoList.js';
import AdminLogin from './Login.js';
import Analytics from './Analytics.js';
import ProtectedRoute from './ProtectedRoute.js';
import NotFound from './NotFound.js';




function App() {
  const [activeView, setActiveView] = useState("upload");

  const handleViewChange = (view) => {
    setActiveView(view);
  };

  return (
    <Routes>
      <Route path="/" element={<AdminLogin />} />
      <Route element={<ProtectedRoute />}>
      <Route
        path="/home"
        element={
          <div style={{ display: "flex", height: "100vh", overflow: "hidden", flexDirection: "column" }}>
            <div style={{ flexShrink: 0 }}>
              <Navbar />
            </div>
            <div style={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
              <div className='bg-dark' style={{ width: "250px", flexShrink: 0, color: "white" }}>
                <Sidebar activeView={activeView} onViewChange={handleViewChange} />
              </div>
              <div style={{ flexGrow: 1, overflowY: "auto", padding: "20px", background: "#f8f9fa" }}>
                {activeView === "upload" ? <Upload />:activeView === "list" ? <List />:<Analytics/> }
              </div>
            </div>
          </div>
        }
      />
      </Route>
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
}

export default App;
